import { AfterViewChecked, AfterViewInit, Component, NgZone, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { UserMgmtService } from "../user-management.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";

import { ExcelService } from "../../dashboard/excel.service";
import Swal from "sweetalert2";
import { Router } from '@angular/router';
import * as moment from 'moment';
import { MatPaginator, MatTable, MatTableDataSource } from '@angular/material';
import { UserClass } from '../user.class';
@Component({
  selector: "app-view-user",
  templateUrl: "./view-user.component.html",
  styleUrls: ["./view-user.component.scss"]
})
export class ViewUserComponent implements OnInit,AfterViewChecked {
  userlist = [];
  public user: UserClass;
  public users: UserClass[];
  statusForm1:FormGroup;
  isTruee:boolean = true
  displayedColumns =
      ['message','firstName','userName','mobile','email','status','subscriptionStatus','courseName','currentWeek','dob','vitalModifyDate','userType','diastolicPerChangeLast','systolicPerChangeLast','bloodSugarPerChangeLast','weightPerChangeLast','stressPerChangeLast','bmiPerChangeLast','emotionalHealthLast','createdOn','actions'];
      dataSource;
      @ViewChild(MatPaginator, {static: true,read:true}) paginator: MatPaginator;
      @ViewChild(MatTable,{static:false}) table: MatTable<any>;
  // @ViewChild(DatatableComponent,{ static: false }) table: DatatableComponent;
  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  resetPasswordFormSubmitted: boolean = false;
  userId: number;
  statusForm: FormGroup;
  resetPasswordForm: FormGroup;
  subscriptiondata: any;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "suspended", name: "Suspended" },
  ];
hourList=["00","01","02","03","04","05","06","07","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23"]
minuteList=["00","01","02","03","04","05","06","07","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59"]


  temp = [];
 
  columns = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 100 ;
  offset: number = 0 ;
  rowCount:number = 100 ;
  userSearchType: string = 'active';
  startDateEpoch: any;
  endDateEpoch: any;
  startDateObj = { year: null, month: null, day: null };
  endDateObj = { year: null, month: null, day: null };
  startDate: any;
  endDate: any;
  usercount: any;
  downloadList: Array<object> = [];
  paymentHistList:Array<object> = [];
  DateRangeQuery: string = "";
  // paymentHistList=[{
  //   lastPaymentDate:1584448638,
  //   lastSubscriptionAmount:20,
  //   brand:'visa',
  //   last4:'3832'
  // }];
  public modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size:"sm"
  };

  inviteCode:string = '';
  searchText: string = "";
  timeZone =(new Date).getTime();
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  constructor(
    private modalService: NgbModal,
    private userMgmtService: UserMgmtService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ExcelService: ExcelService,
    private ngZone: NgZone
  ) { }
  ngOnInit() {
    this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.getUserList();
    this.getdownloadList();
  }
  secondsToDhms(seconds:any) {
    if(seconds ==0){
      return '--'
    }
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600*24));
    var h = Math.floor(seconds % (3600*24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);
    
    var dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : " ";
    var hDisplay = h > 0 ? h + (h == 1 ? " hr " : "  hr ") : " ";
    var mDisplay = m > 0 ? m + (m == 1 ? " min " : " min ") : " ";
    var sDisplay = s > 0 ? s + (s == 1 ? " sec " : "  sec") : " ";
    return dDisplay + hDisplay + mDisplay + sDisplay;
    }

  ngAfterViewChecked(): void {
    if (this.table) {
      //  this.table.updateStickyColumnStyles();
    }
  }
    

  reset() {
    this.inviteCode = '';
    this.startDate = null;
    this.endDate = null;
    this.searchText = '';
    this.userSearchType='active';
    this.textSearch = ''
    this.getUserList();
  
  }

  isDataLoaded:boolean = false;
  sortBy:string = 'message';
  getUserList() {
    this.spinner.show();
    let query ="&offset="+this.offset +"&limit="+this.pageLimit;
    if(this.sortBy){
      query= query+ "&sortBy="+this.sortBy+"&"
    }
    if(this.userSearchType) {
      query = query+ "&status=" +this.userSearchType; 
    }
    this.userMgmtService.SearchUserList(query).subscribe(res => {
      this.isDataLoaded = false;
      if ((res["message"] == "Success")) {
        this.spinner.hide()
        this.userlist =  res.data.userList;
        this.dataSource = res.data.userList;
        this.dataSource = new MatTableDataSource<any>(this.userlist);
        this.temp = res.data.userList;
        this.dataSource.paginator = this.paginator;
        this.isDataLoaded = true;
       // setTimeout(function(){ this.boolean = false; }, 1000);
        this.isDataLoaded = true
        this.rowCount=res.data.totalCount || 100;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }
    });
  }
  onChangePageLimit(){
    this.getUserList()

  }
  textSearch:string = ''
  applySearch() {
    let query;
    if(this.sortBy){
      query= query+ "&sortBy="+this.sortBy+"&"
    }
    if(this.startDate || this.endDate){
      let startEpoc = new Date(this.startDate).getTime();
      startEpoc = startEpoc / 1000;
      startEpoc = startEpoc
      let endEpoc = new Date(this.endDate).getTime();
      endEpoc = endEpoc / 1000; 
      query= query+ "&startDate=" + startEpoc + "&endDate=" + endEpoc;
    }
    if(this.userSearchType) {
      query = query+ "&status=" +this.userSearchType; 
    }
   

    this.spinner.show();

  
    if (this.inviteCode !== '' && this.inviteCode) {
      query = query + '&inviteCode=' +this.inviteCode.trim();
    }
    if (this.textSearch !== '' && this.textSearch) {
      query = query + '&text=' +this.textSearch.trim();
    }
     query= query+"&limit="+this.pageLimit+"&offset="+this.offset;
    this.userMgmtService.SearchUserList(query).subscribe(res => {

      if ((res["message"] == "Success")) {
        this.userlist =  res.data.userList;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount;
        this.spinner.hide();
      } else {

        this.userlist = [];
      }

    });
    this.spinner.hide();
  }
  setPage(pageInfo) {
      this.offset = this.pageLimit * pageInfo.offset;
      this.applySearch();
    
  }
  
  userSearchTypeChanged() {

    let query = "";
    if(this.userSearchType) {
      query = query+ "&status=" +this.userSearchType; 
    }

    this.spinner.show();
    this.userMgmtService.SearchUserList(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.userlist = res.data.userList;
        this.userlist =  res.data.userList;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount || 100;

        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }

    });
  }

  initialiseForms() {
    this.statusForm1 = this.formBuilder.group({
      coachingTime:["",[Validators.required]],  
      title:["",[Validators.required]],
      date:["",[Validators.required]],
      hh:["",[Validators.required]],
      mm:["",[Validators.required]]
    });
  }
  userData:any
  openModal1(content:any, btn:any, data:any) {
    this.initialiseForms();
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      centered: true,
    };
    this.userData = data;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.isModalOpen = true;
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  isLoadingModal:boolean = false;
  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  updateTime(){ 
    this.isLoadingModal = false;
    let request = this.statusForm1.value;
    let date =this.statusForm1.value.date +"T"+this.statusForm1.value.hh+":"+this.statusForm1.value.mm;
    var unix_seconds = ((new Date(date)).getTime()) /1000;
      request.eventEpoch = unix_seconds;
    request['userId']=this.userData['userId']
    delete request['hh'];
    delete request['mm'];
    delete request['date'];
    this.userMgmtService.updateCoachingTime(request).subscribe(res => {
      this.isLoadingModal = false;
      if ((res["message"] == "Success")) {
        this.closeModal();
        Swal.fire("Success", "Coaching time updated successfully!", "success");
      
        this.getUserList();

      } else {
        this.isLoadingModal= false
      }
    }, err => {
      this.isLoadingModal= false
    });
   
  }
  providerList =[];
  openModal(row, content, btn) {
this.userDetails = row;
this.spinner.show();
  let query ='userId='+this.userDetails['userId']
this.userMgmtService.getCoachingDetail(query).subscribe(res => {
  this.spinner.show();
  if ((res["message"] == "Success")) {
    this.providerList = res.data.coachingTimeList;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.modelOptions={
      backdrop: "static",
      keyboard: false,
      size:"lg"
    };
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.isModalOpen = true;
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    this.spinner.hide();
  } else {
    this.spinner.hide();
  }
}, err => {
  this.spinner.hide();
});
    
   
  }


  onStartTimeChange(value: { year: string; month: string; day: string }) {
    let startDateString = value.year + "-" + value.month + "-" + value.day;
    this.startDateEpoch = new Date(startDateString).getTime();
  }

  onEndTimeChange(value: { year: string; month: string; day: string }) {
    let endDateString = value.year + "-" + value.month + "-" + value.day;
    this.endDateEpoch = new Date(endDateString).getTime();
    this.endDateEpoch + 84600000;
  }


  updateUserStatusModal1(row, content, btn) {

    this.userId = row.userId;
    if(row['status'] == 'active') {
      this.statusList= [
        { id: "suspended", name: "Suspended" },
      ];
    }else {
      this.statusList= [
        { id: "active", name: "Active" },
     
      ];
    }
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.isModalOpen = true;
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  paymentHistoryModal(row, content, btn) {

    this.userId = row.userId;
  //  this.getPaymentHistory(this.userId)
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    let   modelOptions1: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    };
    this.modalRef = this.modalService.open(content,modelOptions1);
    this.isModalOpen = true;
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  vitalDetail:any;
  vitalPercentageModal(row, content, btn) {
    this.userId = row.userId;
    this.spinner.show();
    let query = 'userId=' + this.userId;
    this.userMgmtService.getVital(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.vitalDetail = res.data;
        this.spinner.hide();
        this.modalRef = this.modalService.open(content,modelOptions1)
        this.isModalOpen = true;
        
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }

    }, err => {
      this.spinner.hide();
    });
  //  this.getPaymentHistory(this.userId)
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    let   modelOptions1: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    };
    // this.modalRef = this.modalService.open(content,modelOptions1);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  getPaymentHistory(userId:any) {
    this.userMgmtService.historyPayment(userId).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.paymentHistList = res.data.paymentList;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.paymentHistList = [];
      }
    });
  }
  isDownloadClick:boolean = false;
  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    
    if(this.isLoadingDownload == true) {
      this.isDownloadClick = true
      Swal.fire("Warning", "User data is loading,please wait", "warning");
      return
    }
  
    this.ExcelService.exportAsExcelFile(this.downloadList,"UserDetail_"+ month + "/" + day + "/" + year);
  }
  isLoadingDownload :boolean = false;
  getdownloadList(){
    this.isLoadingDownload = true;
    this.userMgmtService.getUserList().subscribe(res => {
      if ((res["message"] == "Success")) {
      this.isLoadingDownload = false;
     let tempList=res.data.userList;
      tempList.forEach(element => {
        let Obj={
          firstName:element['firstName'] || 'NA',
          lastName:element['lastName'] || 'NA',
          userName:element['userName'] || 'NA',
          mobile:element['mobile'] || 'NA',
          email:element['email'] || 'NA',
          dob:element['dob'] ,
          gender:element['gender'],
          userType:element['userType'],
          inviteCode:element['inviteCode'],
          courseName:element['courseData']['currentCourseTitle'],
          courseWeek:element['courseData']['currentWeek'],
          subscriptionStatus:element['subscriptionStatus'],
          CreationDate: moment.unix(element['creationDate']).format("MM/DD/YYYY"),
        }
        Obj['diastolicPerChangeAverage'] = element["bloodPressure"]['diastolicPerChangeAverage'] || 0;
        Obj['diastolicPerChangeLast'] = element["bloodPressure"]['diastolicPerChangeLast'] || 0;
        Obj['systolicPerChangeAverage'] = element["bloodPressure"]['systolicPerChangeAverage'] || 0;
        Obj['systolicPerChangeLast'] = element["bloodPressure"]['systolicPerChangeLast'] || 0;

        
        Obj['bloodSugarPerChangeAverage'] = element["bloodSugar"]['bloodSugarPerChangeAverage'] || 0;
        Obj['bloodSugarPerChangeLast'] = element["bloodSugar"]['bloodSugarPerChangeLast'] || 0;

        Obj['weightPerChangeAverage'] = element["weight"]['weightPerChangeAverage'] || 0 ;
        Obj['weightPerChangeLast'] = element["weight"]['weightPerChangeLast'] || 0;

        Obj['stressPerChangeAverage'] = element["stress"]['stressPerChangeAverage'] || 0;
        Obj['stressPerChangeLast'] = element["stress"]['stressPerChangeLast'] || 0;
        if(element["bmiData"]){
          Obj['BMIPerChangeLast'] = element["bmiData"]['bmi'] || 0;
       
        }else {
          Obj['BMIPerChangeLast'] = 0;
       
        }
        Obj['emotionalHealthLast'] = element["emotionalHealth"]['emotionalHealthPerChangeLast'] || 0;;

        if (element['onTrailPlan'] == true){
          Obj["subscriptionStatus"] = element['subscriptionStatus'] + ' (Trial)';
        }
        else {
          Obj["subscriptionStatus"] = element['subscriptionStatus'] ;
        }
        if(element['subscriptionData']['0'] ){
          if(element['subscriptionData']['0']['nextDueDate']) {
            Obj["nextDueDate"]=moment.unix(element['subscriptionData']['0']['nextDueDate']).format("MM/DD/YYYY") || 'NA';;
            
          }else {
            Obj["nextDueDate"]="NA"
          } 
            if(element['subscriptionData']['0']['lastPaymentDate']){
              Obj["lastPaymentDate"]= moment.unix(element['subscriptionData']['0']['lastPaymentDate']).format("MM/DD/YYYY") || 'NA';
            }else {
              Obj["lastPaymentDate"]="NA"
            }
            if(element['subscriptionData']['0']['lastSubscriptionAmount']) {

              Obj["lastSubscriptionAmount"]=element['subscriptionData']['0']['lastSubscriptionAmount'] ;
            }else {
              Obj["lastSubscriptionAmount"]='NA'
        
            }
            if(element['subscriptionData']['0']['subscriptionAmount']) {
              Obj["SubscriptionAmount"]=element['subscriptionData']['0']['subscriptionAmount'];
          
            }else {
              Obj["SubscriptionAmount"]='NA'
            }
            
         }
        // if(element['hasActivePlan']==false && element['subscriptionStatus'] !=='canceled' && element['subscriptionStatus'] !=='active'  ){
        //   Obj['UserStatus']='Trial'
        // }else{
        //   Obj['UserStatus']=element['status']
        // }
      this.downloadList.push(Obj)
      });
      if(this.isDownloadClick == true) {
        let interval = setInterval(() => {
          this.isDownloadClick = false;
          this.exportAsXLSX()  
        }, 2000);
        
      }
      } else {
      }
    });

  }
 
  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.email.toLowerCase().indexOf(val) !== -1 || !val;
    });
    const email = this.temp.filter(function(d) {
      return d.userName.toLowerCase().indexOf(val) !== -1 || !val;

    });

    this.userlist = temp.concat(email);
    this.rowCount= this.userlist.length;
    // update the rows
    // this.userlist = temp;
    // this.table.offset = 0;
  
  }



  deleteRecord(record: any) {

    this.spinner.show();
    let query = {
      userId:this.userId,
      status:'deleted'
    }
    this.userMgmtService.updateUserStatus(query).subscribe(res => {
      if ((res["status"] = "Success")) {
        this.userSearchType ='active'; 
        this.getUserList();
        this.getdownloadList();
        Swal.fire("Success", "User Deleted successfully!", "success");
        this.closeModal();
        this.spinner.hide();
        
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }

  searchTextChanged(event: any) {
    if (event == "") {
      this.getUserList();
    }
  }

  // USER UPDATE STATUS BLOCK
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }

  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.isModalOpen = true;
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        userId: this.userDetails["userId"],
        status: this.statusForm.controls.newStatus.value
      };

      this.userMgmtService.updateUserStatus(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User status updated successfully!", "success");
          this.closeModal();
          this.getUserList();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
    this.spinner.hide();
  }
  updateInviteCode(test) {
    this.statusFormSubmitted = true;
    if(this.userDetails['inviteCode'] && this.userDetails['inviteCode'].toUpperCase() == this.statusForm.controls.newStatus.value.toUpperCase()){
      Swal.fire({
        type: "error",
        title: "Error",
        text: 'Existing and new invite code cannot be the same.'
      });
      return
    }
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        userId: this.userDetails["userId"],
        inviteCode: this.statusForm.controls.newStatus.value.toUpperCase()
      };

      this.userMgmtService.updateUserStatus(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User invite code updated successfully!", "success");
          this.closeModal();
          this.getUserList();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
    this.spinner.hide();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  getServerData (event) {
    this.getMatTableData(event)
  }

  getMatTableData(event) {
    this.offset = event.pageIndex * event.pageSize;
    this.pageLimit = event.pageSize;
    this.getUserList();
  }
  isModalOpen:boolean = false;
  closeModal(){
    this.modalRef.close()
    this.isModalOpen=false;
  }
  planRequest:any
  SelectDate:any;
  onStartTimeChange1(event) {
    // let startDateString = value.year + "-" + value.month + "-" + value.day;
   
 
       let travelDay = this.statusForm1.value.date.getDate();
       if (travelDay < 10) travelDay = "0" + travelDay;
       let travelMonth = this.statusForm1.value.date.getMonth() + 1;
       if (travelMonth < 10) travelMonth = "0" + travelMonth;
       let travelYear = this.statusForm1.value.date.getFullYear();
       this.SelectDate =  travelYear+'-'+travelMonth+'-'+travelDay;
       let date = this.SelectDate +"T"+this.statusForm1.value.time;
   
       var unix_seconds = ((new Date(date)).getTime()) /1000;
       this.planRequest.eventEpoch = unix_seconds;
      
   }

   syncData(){

    // Swal.fire("Data will be synced in few min!", "success");
    this.userMgmtService.syncUsers('').subscribe(data => {
      this.spinner.hide();

      if ((data["message"] = "Success")) {
        this.closeModal();
        this.getUserList();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
   }
 
}